//=================================== CHANGE ENVIRONMENT ==================================

    const option = 'local'

//=========================================================================================



function env(env) {

    switch (env) {

        case 'local':

            return ['http://94.74.68.198:4200/rules/api',env,'grey darken-1','http://des-reglas.mitur.gob.do/']

        default:

            return ''

    }

}

try{

    module.exports ={

        api:    env(option)[0],

        env:    env(option)[1],

        color:  env(option)[2],

        qrApi: env(option)[3],

        SECRET_TOKEN: 'palolo'

    }

}catch(e){

}
